// accountStatus.ts - Avisa a la pantalla cuando la cuenta de la empresa está bloqueada
// (prueba vencida, suspendida o cancelada). El servidor responde 403 con estos
// mensajes; antes las pantallas solo quedaban vacías sin explicación.

export const ACCOUNT_BLOCKED_EVENT = 'account-blocked';

const BLOCKING_ERRORS = ['Prueba expirada', 'Cuenta suspendida', 'Cuenta cancelada'];

export interface AccountBlockedDetail {
    error: string;
    message?: string;
}

/** Si la respuesta es un bloqueo de cuenta, avisa a la pantalla */
export function notifyIfAccountBlocked(status: number, body: any): void {
    if (status !== 403 || !body || !BLOCKING_ERRORS.includes(body.error)) return;
    window.dispatchEvent(new CustomEvent<AccountBlockedDetail>(ACCOUNT_BLOCKED_EVENT, {
        detail: { error: body.error, message: body.message },
    }));
}
